import React,{useEffect} from 'react';
import { Typography, Box, Card, IconButton } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { styled } from '@mui/material/styles';
import Grid from '@mui/system/Grid';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import LineChart from '../../components/chart/LineChart';
import MenuIcon from '@mui/icons-material/Menu';
import DataTable from '../../components/Datatable/MuiTable'
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import TopDriverTable from '../../components/Datatable/TopDrivers'
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../../../redux/slices/UserSlice"; 
import { fetchOrders } from '../../../redux/slices/OrderSlice';
import { fetchItems } from '../../../redux/slices/ItemSlice';
import { fetchDrivers } from '../../../redux/slices/DriverSlice';



const Home = () => {
 
  const dispatch = useDispatch();
  

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchOrders());
    dispatch(fetchItems());
    dispatch(fetchDrivers());
  }, [dispatch]);
  const { allusers, loading: usersLoading, error: usersError } = useSelector((state) => state.getusers);
  const { allorders, loading: ordersLoading, error: ordersError } = useSelector((state) => state.getorders);
  const { allitems, loading: itemsLoading, error: itemsError } = useSelector((state) => state.getitems);
  const { alldrivers, loading: driversLoading, error: driversError } = useSelector((state) => state.getdrivers);
  const ordercount=allorders?.orders?.length;
  const usercount=allusers?.users?.length;
  const itemcount=allitems?.items?.length;
  const drivercount=alldrivers?.drivers?.length;

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  return (
    <Box sx={{ p: 3 }}>
      <DrawerHeader />
      <Card sx={{ p: "20px", boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
        <Typography variant="body1" sx={{ mb: 2, color: '#000', fontWeight: 600, fontSize: "22px" }}>
          Business analytics
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 2, m: 0, boxShadow: '0 5px 10px rgba(0, 0, 0, .05)', border: '1px solid rgba(180, 208, 224, .5)' }}>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                  <Typography sx={{ mr: 2, color: '#666', fontWeight: 600, fontSize: "14px" }}>
                    Total Earnings
                  </Typography>
                  <IconButton sx={{ p: 0 }} aria-label="copy email">
                    <Box sx={{ display: "flex", bgcolor: "#3c7f06", padding: '3px' }}>
                      <LocalAtmIcon fontSize="medium" sx={{ color: '#fff', fontSize: "30px" }}/>
                    </Box>
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 700, fontSize: "22px" }}>
                  ₹2262.61
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 2, m: 0, boxShadow: '0 5px 10px rgba(0, 0, 0, .05)', border: '1px solid rgba(180, 208, 224, .5)' }}>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                  <Typography sx={{ mr: 2, color: '#666', fontWeight: 600, fontSize: "14px" }}>
                    Total Orders
                  </Typography>
                  <IconButton sx={{ p: 0 }} aria-label="copy email">
                    <Box sx={{ display: "flex", bgcolor: "#3c7f06", padding: '3px' }}>
                      <ShoppingCartIcon fontSize="medium" sx={{ color: '#fff', fontSize: "30px" }} />
                    </Box>
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 700, fontSize: "22px" }}>
                    {ordersLoading ? "Loading..." : ordersError ? ` ${ordersError}` : `${ordercount}`}
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 2, m: 0, boxShadow: '0 5px 10px rgba(0, 0, 0, .05)', border: '1px solid rgba(180, 208, 224, .5)' }}>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                  <Typography sx={{ mr: 2, color: '#666', fontWeight: 600, fontSize: "14px" }}>
                    Total items
                  </Typography>
                  <IconButton sx={{ p: 0 }} aria-label="copy email">
                    <Box sx={{ display: "flex", bgcolor: "#3c7f06", padding: '3px' }}>
                      <InventoryIcon fontSize="medium" sx={{ color: '#fff', fontSize: "30px" }} />
                    </Box>
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 700, fontSize: "22px" }}>
                    {itemsLoading ? "Loading..." : itemsError ? ` ${itemsError}` : `${itemcount}`}
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 2, m: 0, boxShadow: '0 5px 10px rgba(0, 0, 0, .05)', border: '1px solid rgba(180, 208, 224, .5)' }}>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                  <Typography sx={{ mr: 2, color: '#666', fontWeight: 600, fontSize: "14px" }}>
                    Total Clients
                  </Typography>
                  <IconButton sx={{ p: 0 }} aria-label="copy email">
                    <Box sx={{ display: "flex", bgcolor: "#3c7f06", padding: '3px' }}>
                      <PeopleIcon ontSize="medium" sx={{ color: '#fff', fontSize: "30px" }}/>
                    </Box>
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 700, fontSize: "22px" }}>
                  {usersLoading ? "Loading..." : usersError ? ` ${usersError}` : `${usercount}`}
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 2, m: 0, boxShadow: '0 5px 10px rgba(0, 0, 0, .05)', border: '1px solid rgba(180, 208, 224, .5)' }}>
                <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                  <Typography sx={{ mr: 2, color: '#666', fontWeight: 600, fontSize: "14px" }}>
                    Total Drivers
                  </Typography>
                  <IconButton sx={{ p: 0 }} aria-label="copy email">
                    <Box sx={{ display: "flex", bgcolor: "#3c7f06", padding: '3px' }}>
                      <DriveEtaIcon fontSize="medium" sx={{ color: '#fff', fontSize: "30px" }}/>
                    </Box>
                  </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 700, fontSize: "22px" }}>
                    {driversLoading ? "Loading..." : driversError ? ` ${driversError}` : `${drivercount}`}
                  </Typography>
                </Box>
              </Card>
            </Grid>

          </Grid>
          <Grid sx={{ marginTop: "20px" }} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 3, m: 0, bgcolor: 'rgba(110, 137, 175, .0509803922)', boxShadow: '0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <DeviceHubIcon sx={{ color: '#3c7f06' }} />
                    <Typography sx={{ paddingLeft: "10px", color: '#595959', fontWeight: 600, fontSize: "14px" }}>
                      Order InProcess
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ mr: 2, color: '#3c7f06', fontWeight: 700, fontSize: "18px" }}>
                    21
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 3, m: 0, bgcolor: 'rgba(110, 137, 175, .0509803922)', boxShadow: '0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ContentPasteIcon sx={{ color: '#3c7f06' }} />
                    <Typography sx={{ paddingLeft: "10px", color: '#595959', fontWeight: 600, fontSize: "14px" }}>
                      Order InTransit
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ mr: 2, color: '#3c7f06', fontWeight: 700, fontSize: "18px" }}>
                    1
                  </Typography>
                </Box>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Card className="card-cls" sx={{ p: 3, m: 0, bgcolor: 'rgba(110, 137, 175, .0509803922)', boxShadow: '0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <CheckCircleOutlineIcon sx={{ color: '#3c7f06' }} />
                    <Typography sx={{ paddingLeft: "10px", color: '#595959', fontWeight: 600, fontSize: "14px" }}>
                      Order Delivered
                    </Typography>
                  </Box>
                  <Typography variant="body1" sx={{ mr: 2, color: '#3c7f06', fontWeight: 700, fontSize: "18px" }}>
                    21
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Card>
      {/* cart section */}
      <Card sx={{ mt: "20px", p: "0", boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
        <Typography variant="body1" sx={{ mb: 2, color: '#000', fontWeight: 600, p: "10px 20px", fontSize: "21px", borderBottom: '1px solid rgba(0,0,0,.125)', bgcolor: 'rgba(0,0,0,.03)' }}>
          Total Sales
        </Typography>
        <Box sx={{ p: "0px 0px 0px 20px" }}>
          <LineChart />
        </Box>
      </Card>
      {/*  cart section end */}

      {/* last section */}
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Card sx={{ mt: "20px", p: "0", boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'rgba(0,0,0,.03)', p: "10px 20px", borderBottom: '1px solid rgba(0,0,0,.125)' }}>
              <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, fontSize: "21px" }}>
                Recent Orders
              </Typography>
              <MenuIcon fontSize="small" sx={{ color: '#3c7f06' }} />
            </Box>
            <Box sx={{ p: 2 }}>
              <DataTable />
            </Box>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Card sx={{ mt: "20px", p: "0", boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.05)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'rgba(0,0,0,.03)', p: "10px 20px", borderBottom: '1px solid rgba(0,0,0,.125)' }}>
              <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, fontSize: "21px" }}>
                Top Drivers
              </Typography>
              <MenuIcon fontSize="small" sx={{ color: '#3c7f06' }} />
            </Box>
            <Box sx={{ p: 2 }}>
              <TopDriverTable />
            </Box>
          </Card>
        </Grid>

      </Grid>
      {/* last section end */}
    </Box>



  );
};

export default Home;
